import { Iso8601DateTimeString } from '../../../../../../types/Iso8601DateTimeString';
import { Text } from '../../../../../cdl/Text/Text';
import { Tooltip } from '../../../../../cdl/Tooltip/Tooltip';
import { isNoticeDaysExceeded } from '../../../../../common/helpers/isNoticeDaysExceeded.helper';
import { translate } from '../../../../../common/helpers/translate.helper';
import { OrderState } from '../../../../model/OrderModel';

interface NoticeDaysDisplayProps {
    noticeDays?: number;
    dateDelivery: Iso8601DateTimeString;
    orderState: OrderState;
}

export const NoticeDaysDisplay = ({ noticeDays, dateDelivery, orderState }: NoticeDaysDisplayProps) => {
    if (!noticeDays) {
        return null;
    }

    const noticeDaysString = translate('order.detail.daysNotice', { days: noticeDays.toString() });

    if (orderState === OrderState.OPEN && isNoticeDaysExceeded(dateDelivery, noticeDays)) {
        return (
            <Tooltip label={translate('order.detail.etdIsBelowNoticeDays')} side="right" showArrow>
                <Text variant="extraSmall" color="attention.foreground" fontWeight={600}>
                    {noticeDaysString}
                </Text>
            </Tooltip>
        );
    }

    return <Text variant="extraSmall">{noticeDaysString}</Text>;
};
